export default __webpack_public_path__ + "static/media/oxygen7-logo-white.f7015a93.png";